const EventBus = window.EventBus;
export const ToggleListSort = {
  props: [
    'component',
    'prop-title',
    'items',
    'selected',
    'collapse',
    'pivot',
    'disable-responsive',
    'sort-condition',
    'prop-sort',
  ],
  data: function () {
    return {
      show: false,
      checked: [],
      uniqueInList: null,
      theme_directory: window.theme_directory,
      title: this.propTitle,
      sort: this.propSort,
      orderSelected:''
    }
  },
  mounted() {
    EventBus.$on('CLOSE_ALL_OPEN_COMPONENTS', () => {
      if (this.show)
        this.show = false
    });

    this.selectedElement()
  },
  methods: {
    clear() {
      this.title = this.propTitle;
      this.sort = "";
    },
    sortBy(field, order, title) {
      var pathname = window.location.pathname;
      var query = window.location.search || '';

      var a = pathname.replace(/\/?sort_order\/[a-zA-Z]+\//gi, '/');
      var b = a.replace(/\/?sort_by\/[a-zA-Z]+\//gi, '/');

      var url = '/sort_by/' + field + '/sort_order/' + order + '/';
      var finalUrl = b + url + query;
      history.replaceState({}, null, finalUrl.replace('//', '/'));
      this.sort = "";
      this.title = title;
      EventBus.$emit('sortInventory', { field, order });
      this.$parent.sendSignalToInventory();
      this.selectedElement()

    },
    selectedElement(){
                 
      // VALIDATE IF IT HAS ORDER
      if( window.location.pathname.split('/sort_by/').length === 1 ) return ;

      let sort_by = window.location.pathname.split('/sort_by/')[1].split('/')[0]     
      let sort_order = window.location.pathname.split('/sort_order/')[1].split('/')[0]

      let id = `${sort_by}-${sort_order}`;
      let orderElement = document.getElementById(id)

      // VALIDATE IF IT HAS ELEMENT WITH ID
      if(!orderElement) return console.log('There is no element with this id');

      if( this.orderSelected==='' ){
        orderElement.classList.add('selected') 
      }      
      else {    
        let orderSelectedElement = document.getElementById(this.orderSelected)
        orderSelectedElement.classList.remove('selected')
        orderElement.classList.add('selected')      
      }
      
      this.orderSelected=id  
      
    },
    display(component) {
      this.$emit('hideallcomponents', component);
      //console.log("DISPLAY");
      this.show = !this.show;
      this.$emit('update', {
        component,
        checked: this.checked,
      })
    },
    toggle(component) {
      this.$emit('setpivot', component);

      if (this.checked.length == 0) {
        this.$emit('unsetpivot', component);
      }
      this.$emit('updatechecked', {
        component,
        checked: this.checked,
      })
    },
    activateOrderType(id){
      console.log(id);
    }
  },
  watch: {
    checked() {
      //console.log([this.component, this.checked])
      if (this.checked.length > 0)
        this.displayName = this.checked.join(',');
      else
        this.displayName = this.title;
    },
    collapse(v) {
      this.show = v
    },
    items(currentVal) {
      if (currentVal.length == 1) {
        this.uniqueInList = currentVal[0];
        this.checked = [];
        this.checked.push(this.uniqueInList);
      } else if (!this.pivot) {
        this.checked = []
      }
    },
  },
  computed: {
    isResponsive() {
      return !this.disableResponsive == true;
    },
    displayName() {

      if (this.sort == '')
        return this.title;

      var desc = this.$t('high to low');
      var asc = this.$t('low to high');
      if (this.sort == 'Year') {
        desc = this.$t('newest to oldest');
        asc = this.$t('oldest to newest');
      }
      var sortTranslation = this.$t(this.sort.toLowerCase())
      var sortByCondition = { desc, asc };
      if (sortTranslation == "rebatesamount") {
        if (this.propTitle == "Sélectionner le type")
          sortTranslation = "Rabais";
        else
          sortTranslation = "Discount";
        if (this.sortCondition == "asc")
          this.sortCondition = "desc"
        else
          this.sortCondition = "asc";
        return `${sortTranslation}: ${sortByCondition[this.sortCondition]}`;
      }

      return `${sortTranslation}: ${sortByCondition[this.sortCondition]}`;
    }
  }
}
